export const MainCommercialExteriorPainting = {
    "imageUrl": "/assets/imgs/services/3CommercialExteriorPainting/fondo.png",
    "eyebrow": "Commercial Exterior",
    "title": "Painting",
    "headingSpan": "PROTECT & EXTEND",
    "heading": "YOUR BUILDING",
    "description": "A fresh coat of paint does more than just enhance your building’s appearance - it serves as a protective barrier against the elements, preventing moisture damage, UV exposure, and surface deterioration. At HRD Painting & Restoration, we specialize in high-quality commercial exterior painting, delivering long-lasting finishes that enhance curb appeal and structural longevity.",
    "highlightSpan": "The best Building Envelope Renewal",
    "highlight": " / High-Rise Painting & Restoration services.",
    "button": {
        "text": "Request a Quote",
        "url": "/quote"
    }
};